import demo from "./demoDatasets";

const translationEN = {
    //
    // GENERAL NAMESPACES
    //

    language: {
        Name: "English",
    },

    common: {
        // This namespace could be used for general or common text variables that are used across different parts in the application.
        SelectButton: "Select",
        LearnMoreButton: "Learn More",
        notFoundTitle: "Page not found",
        notFoundDescription: "Sorry, the requested page could not be found.",
        Agree: "Yes",
        Disagree: "No",
        Warning: "Warning"
    },
    erros: {
        // This namespace could be used for error messages.
    },
    messages: {
        // This namespace could be used for general messages or notifications
    },
    forms: {
        // This namespace could be used for form-related text variables, such as labels, placeholders, and validation messages.
    },
    navigation: {
        // This namespace could be used for text variables related to navigation, such as menu items, breadcrumbs, or page titles.
    },
    //
    // COMPONENT-SPECIFIC NAMESPACES
    //

    // Hints always start with the word Hints. If you notice that they are repeating themselves it might make sense
    // to have a section Hints

    // This only has the missing runs info text extracted, once i can see the plots i will change that part
    analyzer: {
        Markers: "markers",
        Scatter: "scatter",
        Black: "black",
        Dash: "dash",
        Line: "line",
        Actual: "Actual",
        Predicted: "Predicted",
        LabelTrainingSetPredictions: "Training Set Predictions",
        LabelValidationSetPredictions: "Validation Set Predictions",
        LabelOptimalLine: "Optimal Line",
        LabelScatterPlot: "Scatter Plot of Actual vs Predicted Data",
        LabelAbsolutError: "Absolute Percentage Error",
        LabelCRPS: "CRPS Percentage",
        LabelFeatureImportancePlot: "Feature Importance",
        LabelSHAPPlot: "SHAP (SHapley Additive exPlanations)",
        LabelNRMSE: "nRMSE",
        TrainingSet: "Training Set",
        ValidationSet: "Validation Set",
        TestSet: "Test Set",
        runDataQuery: "runData ?",
        descriptionDeviation:
            "MAE = Mean Absolute Error \n nRMSE = Normalized Root Mean Squared Error",
        ScatterPlot: "Scatter Plot",
        DescriptionScatterPlot:
            "This plot shows how well a machine learning model predicts values. The predictions from the model are displayed as dots. The diagonal line represents the ideal prediction - if the model was perfect, all points would fall on this line. The further the orange points are from the line, the less accurate the model's predictions are.",
        BoxPlot: "Box PLot",
        DescriptionBoxPlot:
            'The box plot shows the distribution of the absolute percentage error values across a dataset or a set of experiments. It includes a box that represents the interquartile range (IQR) of the losses, as well as "whiskers" that extend to the minimum and maximum values within a certain range. The plot also includes individual points that represent outlier values. This visualization is useful for understanding the spread and central tendency of the loss values and identifying any extreme values or trends.',
        // Used
        PageTitle: "Analyze Experiment Run Results",
        SelectedRunDropdown: "Selected Run",
        SelectedPipelineStepDropdown: "Selected Pipeline Step",
        DescriptionSelectRun: "Select the Run you want to analyze.",
        DescriptionFeatureImportance: "This feature importance plot shows the importance of the features for the AI model. The value on the X-axis represents the importance." +
            " How the importance value is determined varies depending on the type of AI model. The importance method used here is simple and is primarily intended to provide an initial assessment " +
            "of the importance of the features to each other. For datasets with many features this estimation is only conditionally meaningful. The significance is particularly limited if there are " +
            "features in the data set that contain similar information. \n" +
            "\n" +
            " For a more accurate assessment of which features are important for the AI model, we recommend performing a 'feature selection' experiment.",
        DescriptionSHAP: "SHAP (SHapley Additive exPlanations)¹ is a method to improve the explainability of AI models. \n" +
            "SHAP represents how features affect the target within the model. This allows for a better understanding of the predictions of the AI model. \n" +
            " \n" +
            "In this SHAP beeswarm plot, up to 15 features are shown that have the greatest impact on the target in the AI model (according to the SHAP method i.e. SHAP value) . " +
            "The order on the Y-axis represents the impact level (from top to bottom). On the X-axis, for each feature the validation set data points are represented as dots. " +
            "The color of the dots represents the value of the feature and the position of the dots on the X-axis, represents the SHAP value, i.e. the impact the feature has on the target.  " +
            "The number of data points is reduced to 1,000 for large data sets using sampling.",
        ReadMoreSHAPExplanation: "Detailed explanation about the SHAP Beeswarm Plot",
        NoExperiments:
            "Your current experiment has no trained models that can be analyzed. \n You can ",
        NoExperiments_LinkText: "start a Training Pipeline",
        NoExperiments_AfterLink: " to obtain a trained model.",
        AFSScatterTitle: "Overview of Automatic Feature Selection",
        AFSScatterDescriptionBody:
            "In Automatic Feature Selection (AFS), features that have the least impact on the model output are iteratively removed. " +
            "The number of features removed is determined randomly. " +
            "The dark line (number of selected features) shows " +
            "the progression of AFS. \n After each AFS iteration, the model is tested." +
            " The corresponding model error " +
            "(here, Normalized Root Mean Squared Error) is represented by the light line. \n" +
            "After AFS, the model and feature selection with the lowest error and most robust performance are chosen (green point).",
        AFSHeatmap: "Selected Features Over Time",
        AFSHeatmapDescriptionBody:
            "This plot provides a detailed view of which features were removed during the iterations (AFS training).",
        ConfusionMatrixDescriptionTitle: "Confusion Matrix",
        ConfusionMatrixDescriptionBody:
            "The confusion matrix is a method for evaluating the prediction quality of a classification model. " +
            "The table indicates how well a model predicts each class. It shows how large the proportion of correctly " +
            "and incorrectly assigned predictions is for each class by relating the predicted to the actual classes for each input. " +
            "The matrix also serves as the basis for calculating other quantitative metrics such as accuracy. ",
        ConfusionMatrixValTitle: "Confusion Matrix Validation Set",
        ConfusionMatrixXTitle: "Predicted Class",
        ConfusionMatrixYTitle: "True Class",
        ConfusionMatrixTrainTitle: "Confusion Matrix Training Set",
        ConfusionMatrixColorBarLabel: "Propotion",
        ConfusionMatrixCaption: "",
        AccuracyTableValLabel: "Accuracy \n on Validation Set",
        AccuracyTableTrainLabel: "Accuracy \n on Training Set",
        RegressionMetricTitle: "Metric",
        RegressionMetricTableValLabel: "on Validation Set",
        RegressionMetricTableTrainLabel: "on Training Set",
        ForecastMean: "Distribution Mean",
        ForecastMeanSectionHeadline: "Results and Plots for the Distribution Mean",
        GoToPipelineButton: "Go to Pipeline and Hyperparameter Plots",
        DeleteRunButton: "Delete Run",
        DownloadModelButton: "Download Model",
        DownloadOptions: "Download Options",
        IncludeValidation: "Download Validation Data",
        IncludeTrainData: "Download Train Data",
        Warning: "⚠️ Only if no Conda is present, env.yaml is included in the standard download and is the recommended installation method",
        IncludeWindows: "Download Windows Python Environment",
        IncludeLinux: "Download Linux Python Environment",
        Cancel: "Cancel",
        CreatingDownloadZip: "Creating Download Zip File",
        CloseWindow: "Close Window",
    },

    currentExperimentSelector: {
        CurrentDatasetDropdown: "Current Dataset",
        NoDataset: "No dataset created yet",
        AddDatasetButton: "Add New Dataset",
        CurrentExperimentDropdown: "Current Experiment",
        NoExperiment: "No experiment created yet",
        AddExperimentButton: "Add New Experiment",
    },

    datasetConfigurator: {
        DatasetNameFillable: "Dataset Name",
        FileSettingsTitle: "File Settings",
        CSVEncodingDropdown: "CSV Encoding",
        CSVDelimiterDropdown: "CSV Delimiter",
        DatasetSettingsTitle: "Dataset Settings",
        UseCustomVal: "Use Custom Validation Set",
        UseTest: "Use Test Set",
        TablePreviewTitle: "Table Preview",
        TableDescription1: "First rows of your uploaded data",
        TableDescription2: "Columns",
        TableDescription3: "Rows",
        ErrorDemoDatasetAlreadyExists: "Dataset with this name already exists",
        HintDatasetName:
            "This name is for clarity purposes and is up to preference",
        HintEncoding: "Needed to avoid formatting problems",
        HintDelimiter: "This separator separates the columns in your CSV file",
        HintDatasetSettings: "Options to use custom validation and test datasets",
    },

    datasetCreator: {
        UploadDataButton: "Upload Data",
        UploadInProgress: "Data is being uploaded ...",
        DatasetCreatedButton: "Dataset created",
        ConfigureCheckButton: "Configure & Check Data",
        CreateDatasetError: "Failed to create dataset ",
        FailedUploadError: "Failed to upload data ",
        DatasetCreationInProgress: "Dataset is being created ...",
        DatasetCreated_1: "Dataset ",
        DatasetCreated_2: " Created",
        DatasetCreated_3: "A new dataset with the name ",
        DatasetCreated_4: " was successfully created",
        BackButton: "Back",
        StartCreationButton: "Start Dataset Creation",
    },

    datasetError: {
        MissingColumnValues: "Missing column names ",
        TooManyRows: "the dataset contains too many rows. Maximum 1 000 000 rows are allowed. {{max_rows, number}} rows are available",
        TooFewRows: "the dataset contains not enough rows. Minimum 20 rows are needed. Only {{min_rows, number}} rows are available",
        TooManyColumns: "the dataset contains too many columns. Maximum 10 000 columns are allowed. {{max_columns, number}} columns are available",
        TooFewColumns: "the dataset contains not enough columns. Minimum 3 columns are needed. Only  {{min_columns, number}} columns are available",
        FileSizeTooBig: "The file size ~{{fileSize, number}}MB is too big. The maximum allowed size is 1000MB",
        ColumnNamesTooLong: "Please note that some column names exceed the maximum recommended character size of 24, which is set to ensure proper information display. You can rename these columns in the list below",
        DatasetNameAlreadyExists: "Dataset with this name already exists",
    },

    datasetAbortUpload: {
        Warning: "You are about to abort the upload. Do you want to continue?"
    },

    datasetEditor: {
        ColumnNamesTooLongWarning: "Long column names",
    },

    examples: {
        PageTitle: "Experiment Examples",
        PageTitleDatasets: "Beispiel Datensätze",
        Example1Title: "Outlier Detection in a Temperature Sensor",
        Difficulty: "Difficulty",
        DatasetInformation: "Dataset Information",
        NumDatapoints: "Number of Sensor Readings/ Data Points",
        NumFeature: "Number of Features",
        Automatically:
            "\n Using the KI-Lab.EE AutoML Tool, the following step were conducted automatically:",
        Step1: "1. Preprocessing of the Dataset",
        Step2:
            "2. Training of a Regression Model with automatic hyperparameter\n tuning",
        Step3:
            "3. Training of an Error Model, predicting the uncertainty of the trained Regression Model",
        Step4: "4. Plot Generation for Model Evaluation",
        Step5: "5. Provision of a downloadable and executable model",
        ButtonImportExample: "Import Example-Dataset and view",

        // Example 1
        TitleExample1: "Erkennung von Ausreißern im Temperatursensor",
        DatasetFileNameExample1: "",
        TeaserImageUrlExample1:
            "https://images.pexels.com/photos/6434745/pexels-photo-6434745.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        DescriptionExample1:
            "\n The problem being addressed is the identification of abnormal readings from a temperature sensor, which could indicate a malfunction or other issue.",
        DifficultyRatingExample1: 2,
        NumDatapointsExample1: 802,
        NumFeaturesExample1: 13,
        TargetsExample1: "Messwert des Temperatursensors",
        OutcomeExample1:
            "\nThe outcome of this experiment is a ML model that can detect outliers with a detection rate of 97%, which is a highly accurate and reliable way of identifying abnormal readings from the sensor data and can provide valuable insights to detect malfunction or other issues.\n",
        FeaturesExample1:
            '4 (DayofYear, HourofDay, WindSpeed, Pressure, Humidity)"',
        // Example 2
        TitleExample2:
            "24h Vorhersage von Erzeugnissen einer Photovoltaik-Dachanlage",
        DatasetFileNameExample2: "☀️ Photovoltaik",
        TeaserImageUrlExample2:
            "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        DescriptionExample2:
            "\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
        TargetsExample2: "Güteklasse der Milch: 0, 1, 2",
        DifficultyRatingExample2: 4,
        NumDatapointsExample2: 1200,
        FeaturesExample2: "4 (At vero eos et accusam et justo duo dolores)",
        OutcomeExample2:
            "\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.",
        // Example 3
        TitleExample3: "Ermittlung der Milchqualität",
        DatasetFileNameExample3: "🐄 Milch Qualität",
        TeaserImageUrlExample3:
            "https://images.pexels.com/photos/3214973/pexels-photo-3214973.jpeg",
        DescriptionExample3:
            "\nBeispiel eines Datensatzes eines Molkereibetries. Anhand von Messdaten einzelner Milchproben soll mit Hilfe von KI-Modellen die Güteklasse der Milch bestimmt werden.",
        DifficultyRatingExample3: 1,
        NumDatapointsExample3: 200,
        FeaturesExample3: "6 (z.B. pH Wert, Temperatur, Farbe, ...)",
        TargetsExample3: "Güteklasse der Milch: 0, 1, 2",
        OutcomeExample3: "\n",
        // Example 4
        TitleExample4: "Vorhersage der Beton Druckfestigkeit",
        DatasetFileNameExample4: "🏗️ Beton Druckfestigkeit",
        TeaserImageUrlExample4:
            "https://images.pexels.com/photos/2628393/pexels-photo-2628393.jpeg?auto=compress&cs=tinysrgb&w=1600",
        DescriptionExample4:
            "\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
        DifficultyRatingExample4: 2,
        NumDatapointsExample4: 200,
        NumFeaturesExample4: 6,
        FeaturesExample4: "4 (At vero eos et accusam et justo duo dolores )",
        TargetsExample4: "Güteklasse der Milch: 0, 1, 2",
        OutcomeExample4:
            "\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.",
    },

    experimentConfigurator: {
        PageTitle_1: "Create",
        PageTitle_2: " Experiment for ",
        TargetTitle: "Target Settings",
        TargetDescription: "What are the columns you want to predict?",
        TargetDropdown: "Target Column(s)",
        HintTarget: "Select the target attribute you want to predict", // TBD
        FeatureTitle: "Feature Settings",
        FeatureDescription:
            "Per default, all non-target columns are treated as Features. Here you can make some modifications.",
        IgnoreDropdown: "Ignored Column(s)",
        IdDropdown: "ID Column",
        HintIgnore:
            "Select the columns to be ignored for model training (optional)", // TBD
        NoID: "No ID Column",
        HintID:
            "Select the column that contains the unique IDs for the data records (optional)", // TBD
        TimestampDropdown: "Timestamp Column",
        NoTimestamp: "No Timestamp Column",
        HintTime:
            "Select the column that contains the timestamps for the data records (optional)", // TBD
        ExperimentSettingsTitle: "Experiment Settings",
        ExperimentSettingsDescription: "Additional Settings",
        ExperimentNameFillable: "Experiment Name",
        HintExperimentName:
            "This name is for clarity purposes and is up to preference", // TBD
        ExperimentCommentsFillable: "Your Experiment Comment",
        HintExperimentComments: "Your additional comments", // TBD
        NoComment: "Comment",
        TimestampTitle: "Timestamp",
        FeaturePreviewTitle: "Features Preview",
        ExplainFeaturesTable: "First rows of your feature data",
        NoFeatures: "No feature columns selected",
        TargetPreviewTitle: "Targets Preview",
        ExplainTargetTable: "First rows of your target data",
        NoTarget: "No target columns selected yet",
        SaveAndProcessButton: "Save Settings & Start Data Processing",
        SuccessExperimentProcessingStarted: "Experiment processing started",
        HintNoDatasetYet:
            "There is no dataset for which an experiment could be created. Please create a dataset first.",
        ErrorExperimentAlreadyExists:
            "An Experiment with the name already exists for the dataset. Please choose a different name.",
        ErrorTargetDoesNotMatchExperimentType:
            "Your selected target does not match the experiment type. Please choose a different target or type.",
        "Error undefined": "",
        "Error Target column is not set correctly.":
            "Target column(s) are not set correctly",
        "Error Timestamp column is not set correctly.":
            "Timestamp column is not set correctly",
        "Error Id column is not set correctly.": "Id column is not set correctly",
        "Error Ignored column is not set correctly.":
            "Ignored columns are not set correctly",
        "Error Experiment name already exists.":
            "An experiment with the name already exists for the dataset.",
    },

    experimentErrors: {
        FailedCreationError: "Failed to create Experiment",
        ExperimentNameAlreadyExists: "An Experiment with this name already exists",
        ExperimentTargetTypeInvalid: "The selected Targets '{{target_columns, list}}' are not numerical or contains NaNs. Nonnumerical types are not supported yet",
        ExperimentTargetNotUnique: "The selected Target has too many unique values",
        ExperimentTimestampInvalidType: "The selected Timestamp is invalid",
        ExperimentIDNotUnique: "The selected ID column is not unique",
        ExperimentIDInvalidType: "The selected ID type '{{type}}' is not allowed. Only 'int64' and 'object' are allowed ",
        FailedDeletion: "The chosen experiments could not be deleted"

    },

    experimentRoutes: {
        MissingExperiment_1: "An Experiment with the name",
        MissingExperiment_2: "could not be found for your current Dataset.",
        MissingDataset_1: "A Dataset with the name",
        MissingDataset_2: "could not be found.",
    },

    experimentTypeSelector: {
        PageTitle: "Create an Experiment for your Dataset",
        PageInstructions: "Choose a Task",
        CreateExperimentButton: "Create Experiment",
        ClassificationTitle: "Classification",
        ClassificationDescription:
            "Classification describes a machine learning technique that uses a set of input data (features) to assign them " +
            "to a specific class (label). The assignment is done by applying an algorithm from the field of supervised learning. " +
            "The goal of the model is to map the relationship between input data and the classes in such a way that it is able to " +
            "determine the class for new, not yet seen inputs. The number of classes as well as the unique assignment of all data " +
            "to one class each must be given in the training data set in order to be able to train a model.",
        RegressionTitle: "Regression",
        ExperimentNameStart: "My ",
        ExperimentNameEnd: " Experiment",
        RegressionDescription:
            "Regression is a type of supervised learning and aims to predict a dependent variable based on one or more independent " +
            "variables. Thus, a model is created that is capable of mapping the underlying relationship between input characteristics " +
            "and the output to make predictions. The basic idea here is to find the best fitting line or curve that can represent " +
            "the relationships between variables in the data. Both continuous and categorical variables can be used as input. ",
        ForecastTitle: "Forecast",
        ForecastDescription:
            "In forecasting, certain machine learning algorithms are used to predict future events or outcomes based on historical data. Forecasting is a special form of regression focussing on past patterns in order to make statements about the future. In addition, the uncertainty of the prediction is also specified in this type of experiment.",       AnomalyDetectionTitle: "Anomaly Detection",
        AnomalyDetectionDescription:
            "To identifying unusual patterns or instances in your dataset that deviate from the norm, you can train an error model. Anomaly Detection can be done in different ways, here you can train two regression models that will be combined as error model.",
        NotSureTitle: "Not sure what kind of task you need?",
        NotSureDescription:
            "Check-out our examples to get a better understanding about what tasks solves which problems.",
        ShowExamplesButton: "Show Examples",
    },

    fileUpload: {
        Requirements: "File Requirements",
        FileType: "File Type",
        FileSize: "File Size",
        NumberRows: "Number of Rows",
        NumberCols: "Number of Columns",
        Encoding: "Encoding",
        EncodingValues: "UTF-8 or ISO 8859-1",
        Formatting: "Formatting",
        FirstRow: " First row must contain column names",
        EachCol: " Each column must be named",
        MultiIndexing: " No Multi-Indexing",
        UploadCSVButton: "Upload .csv file",
    },

  hints: {
    CloseButton: "Close",
    NotYetProcessed: "You current Experiment has not been processed yet",
  },

  home: {
    Welcome: "Welcome to the KI-Lab.EE AutoML Tool!",
    Goals:
        "This platform is designed to apply common machine learning techniques using AutoML (Automated Machine Learning) easily " +
        "and without the use of code. This enables an introduction to the topic of machine learning regardless of whether " +
        "programming knowledge or a deeper prior knowledge of the topic is available. On this platform you can run, " +
        "store and evaluate experiments based on your own data sets. You also have the possibility to try out simple application examples " +
        "with the help of our sample data sets. In addition, you will find some tutorials that guide you step by step through the " +
        "individual steps of the application. \n\n "+
        "To get started, choose one of the following options:",
    TutorialExampleTitle: " Check out our example experiments.",
    TutorialExampleBody:
      "We've curated a selection of pre-built experiments for common tasks such as\
                                    forecasts, classification, anomaly detection, and more.\
                                    You can run these examples as-is or use them as a starting point for your own\
                                    experiments.",
    TutorialDatasetTitle: " Upload a dataset and create your first experiment.",
    TutorialDatasetBody:
      "Our platform will automatically analyze your data and suggest appropriate models for\
                                    your task. You can then customize and run the experiment\
                                    with just a few clicks.\n",
    TutorialExampleButton: "Show Example Experiments",
    TutorialDatasetButton: "Upload Dataset",
  },

qualityCheck: {
      PageTitle: "Check Data Quality for your Experiment",
      ErrorTitle: "Error",
      ErrorsTitle: "Errors",
      ErrorDescription: "The following errors were found in your data:",
      WarningTitle: "Warning",
      WarningsTitle: "Warnings",
      WarningDescription: "The following aspects of the data might be problematic:",
      NoErrors: "No errors found.",
      NoWarnings: "No warnings found",
      possibleProblems: "Possible problems include:",
      colsWithImplausibleValuesText: " contains suspicious values.",
      toManyCategoriesText: " contains too many categories.",
      toManyNansText: " contains too many NaN values.",
      constantColValuesText: "One or more of the target variables always contain the same value.",
      allFeaturesConstantText: "All variables contain the same values.",
      allTargetsConstantText: "All target variables contain only one value.",
      colsWithIntolerableManyCategoriesText: " contains too many categories.",
      colsWithImplausibleValuesDetails: "\n The values differ so much from the other values in the column that it is unlikely that they are normal outliers. There is a probability that they are incorrect values, which should be inspected again, otherwise they can negatively influence the model",
      toManyCategoriesDetails: "\n Too many categories can lead to limited model quality depending on the data structure and model type.\n"+
      "\n",
      colsWithToManyCategoriesNumber: "\n The number of categories in the column is: ",
      allFeaturesConstantDetails:"\n It does not make sense to train a model on this data. There is likely an error in the dataset.",
      allTargetsConstantDetails: "\n It does not make sense to train a model on this data. It is very likely that there is an error in the dataset. ",
      colsWithIntolerableManyCategoriesDetails: "\n With this number of categories, a meaningful model cannot be computed. There is likely an error in the dataset.",
      manyCategoriesProblems: "Dimensionality Problem: \n" +
          " With each additional category in a column, the number of dimensions in the dataset increases.\n" +
          " In high-dimensional spaces, many algorithms require significantly more data to make reliable predictions. \n" +
          "\n" +
          "Overfitting: \n" +
          " A model may tend to overly adapt to the specific categories in the training dataset if there are too many.\n" +
          " This can lead to the model performing well on the training data but poorly on new, unknown data. \n" +
          "\n" +
          "Time and Computational Resources:\n" +
          " Processing datasets with many categories can be very time-consuming. Training models that work with high-dimensional data often requires powerful hardware and can take a long time. \n" +
          "\n" +
          "Interpretability: \n" +
          " If a column has many categories, it may be more difficult to understand and interpret the results of the model.\n" +
          " It is harder to determine which categories have a strong influence on the predictions.\n" +
          "\n" +
          "Noise and Irrelevance: \n" +
          " It is more likely that a column with many categories also contains misleading or noisy information\n" +
          " that could potentially harm the model. ",
      toManyNansProblems: "Loss of Information: \n" +
          " The information contained in the column is limited. If too many values are missing in a column, \n" +
          "potentially important knowledge is lost.\n" +
          "                                                                \n" +
          "Biasing Analysis and Predictions:\n" +
          " Missing values can lead to biased statistical analyses. This also applies to Machine Learning models, \n" +
          " as they may struggle to recognize meaningful patterns if too many missing values are present within a column.",
      constantColValuesProblems: "Lack of Information:\n" +
          " A constant target does not provide useful information for modeling. It does not contribute to improving the \n" +
          " predictions. If a target always has the same value, it does not provide variability or information to distinguish between \n" +
          " different inputs.",
},

  inspect: {
    PageTitle: "Inspect Experiment Data",
    NumRows: "Number of Rows/ Data Points",
    NumFeatures: "Number of Features",
    NumTargets: "Number of Targets",
    ValRatio: "Training / Validation Ration",
    UseTestset: "Use Testset",
    ExplanationTestset: "You uploaded a testset for the experiment",
    IsTimeseries: "Is Timeseries Data",
    ExplanationTimeseries:
      "Meaning, your dataset contains consecutive timestamps",
    IsSeasonal: "Is Seasonal Data",
    ExplanationSeasonal: "Meaning, your dataset spans over more than a year",
    TargetPlots: "Target Plots",
    TargetDropdown: "Selected Target",
    HintTarget: "Select the attribute that you want to inspect", // TBD
    TargetOverTime: "Target Over Time",
    TargetDistribution: "Target Distribution",
    DatasetType: "Dataset Type",
    SeasonalDistribution: "Season Distribution",
    SeasonalDistributionXLabel: "Year",
    WarningPlots: "Warning Plots",
  },

    login: {
        PageTitle: "",
        Description: "",
        UidFillable: "",
        SaveButton: "",
    },

    overview: {
        MyDatasetsTitle: "My Datasets",
        MyExperimentsTitle: "My Experiments",
        DataButton: "Add New Dataset",
        ExperimentButton: "Add New Experiment",
        DeleteDatasetButton: "Delete dataset",
        DeleteExperimentButton: "Delete selected experiments",
        DeleteDatasetWarning: "You are about to delete this dataset and all corresponding experiments. Do you want to continue?",
        DeleteExperimentWarning: "You are about to delete all selected experiments. Do you want to continue?",
        DeleteRunWarning: "You are about to delete this training run and the corresponding ML model. Do you want to continue?",
    },

    processingStatus: {
        PageTitle_1: "Your Experiment",
        PageTitle_2: "is currently being processed.",
        Description:
            "The following steps are currently being carried out. Depending on your dataset size, this can take up to 10 minutes",
        LabelConstants: "Checking Data for Constant Columns",
        DescriptionConstants:
            "In this step, the data set is checked for content consistency. If there are rows in which only the same value is always " +
            "entered, this does not provide any usable information for training the machine learning model and is also an indication " +
            "of an error in the data entry. For these reasons, such data is removed from the dataset. ",
        LabelOneHot: "Checking Data for One-Hot-Encoding",
        DescriptionOneHot:
            "In this step, categorical data is transformed into numerical data to convert the data into a form that can be understood by machine learning algorithms. " +
            "In this process, each category is converted into its own column, and a 1 is placed in the corresponding column if the category is " +
            "true, and a 0 is placed otherwise. The result is a binary representation of the categories, for example, the categorical data " +
            "\"red\", \"blue\" and \"green\" become [1,0,0] for \"red\", [0,1,0] for \"blue\" and [0,0,1] for \"green\" by the one-hot encoding.",
        LabelNormalize: "Normalizing Data",
        DescriptionNormalize:
            "Data normalization is a process of scaling numerical data to a common range, such as between 0 and 1. " +
            "It is needed for machine learning because many algorithms are sensitive to the scale of the input data and can perform poorly or produce biased results when the input data is not normalized. Normalizing the data helps to ensure that each feature is on a similar scale, improving the accuracy and stability of machine learning algorithms.",
        LabelMissingValues: "Replacing Missing Values in Features",
        DescriptionMissingValues:
            "Machine Learning models like Neural Networks cannot handle missing data in the features (NaN values)." +
            "Replacing missing values is, therefore, a crucial step in the data preprocessing phase that aims to handle such missing data. This can be done by either dropping the missing values or imputing them with statistical methods such as mean, median, or mode. The choice of method depends on the amount of missing data and the nature of the feature.",
        LabelAnomalies: "Checking Data for typical Anomalies",
        DescriptionAnomalies:
            "The data is checked for typical data anomalies. These include atypical outliers, unusual distributions or possible measurement errors. More about this topic in the Inspections tab",
        ReadNextButton: "Read Next",
        BackButton: "Back",
        CompletedMessage: "All steps completed - you're finished!",
        ProceedButton: "Start working with the experiment",
    },

  sidebar: {
    DemoNotification:
      "Please note that the current status of this tool is implemented for demonstration purpose only. It does not start actual trainings.\n More features will follow in the future.",
    DataExplorerButton: "Dataset Explorer",
    CurrentExperimentButton: "Current Experiment",
    UseCasesButton: "Example Use Cases",
    DataQualityButton: "Check Data Quality",
    InspectButton: "Inspect Data",
    ConfigureButton: "Configure & Run Training",
    AnalyseButton: "Analyze Results",
    CompareButton: "Compare Runs",
    OngoingButton: "Ongoing & Scheduled Runs",
    MyDatasetsButton: "My Datasets & Experiments",
  ScheduledAndRunningButton: "Scheduled & Running",
    Export: "Export Model",
    MyAccountButton: "My Account",
    MyAccountInfo: "Account Info",
    MyAccountLogout: "Logout",
    AboutLink: "About KI-Lab.EE",
    PrivacyLink: "Privacy Policy",
    ImprintLink: "Imprint",
    Copyright: "ZSW © 2023"
  },

    languageSelector: {
        Label: "Language",
        Title: "Choose Language",
    },

    // Same as in Analyzer, maybe move into a general?
    runs: {
        PageTitle: "Runs for this Experiment",
        Results: "Results",
        NoExperiments:
            "Ihr aktuelles Experiment verfügt über keine trainierten Modelle, die verglichen werden können. \n Sie können eine ",
        NoExperiments_LinkText: "Trainings-Pipeline",
        NoExperiments_AfterLink: " starten, um ein trainiertes Modell zu erhalten.",
        AEValPlotTitle: "Absolute Error Validation Set",
        AETrainPlotTitle: "Absolute Error Training Set",
        AccuracyValPlotTitle: "Accuracy Validation Set",
        AccuracyTrainPlotTitle: "Accuracy Training Set",
        AccuracyPlotYLabel: "Accuracy",
        AccuracyPlotXLabel: "Class",
    },
  trainer: {TitleRunCreation: "Create a new Run or Extend Existing Runs",
    TitleTrainingConfiguration: "Configure & Run Model Training",
    TitleExtendRun: "Extend Run",
    DropdownOptiMethod: "AutoML Optimization Method",
    HintOptiMethod: "The AutoML methods for automatically optimizing the hyperparameters of your model",
    DataBalancingTitle: "Data Balancing",
    DropdownBalancerMethod: "Data Balancing Method",
    SelectedNoDataBalancer: "No Data Balancing",
    HintBalancerMethod: "The method for balancing the data set, is only needed for imbalanced data sets. A dataset is imbalanced if the target classes are not equally distributed.",
    DropdownRunsLabel: "Selected Run",
    DropdownRunsNew: "New Run",
    HintDropdownRuns: "Create a new run or select a finished run to add further pipline steps",
    InputRunName: "Run Name",
    HintRunName: "This name is for clarity purposes and is up to preference",
    PageDescription: "Select Model Type",

    DropdownRunName: "Run Name",
    HintModelType: "Select the model type that best suits your task", // TBD
    TitleRandomForest: "Random Forest",
    DescriptionRandomForest: "A supervised machine learning algorithm that assembles multiple random decision trees into a forest. " +
        "It is suitable for a wide range of use cases and is applicable to many different types of data structures.",
    QualityRandomForest: 4,
    SpeedRandomForest: 5,
    TitleNeuralNetwork: "Neural Network",
    DescriptionNeuralNetwork: "A supervised machine learning algorithm that mimics the structure of the human nervous system. " +
        "Data is passed through multiple interconnected artificial neurons. " +
        "Neronal networks are particularly suited to tasks in which complex patterns or relationships in the data need to be recognized.",
    QualityNeuralNetwork: 5,
    SpeedNeuralNetwork: 2,
    TitleGaussianProcess: "Gaussian Process",
    DescriptionGaussianProcess: "A non-parametric Bayesian algorithm coming from the field of stochastic processes and probability theory. " +
        "The method is particularly suitable in the case of a limited or incomplete data set.",
    QualityGaussianProcess: 4,
    SpeedGaussianProcess: 4,
    TitleLSTMNetwork: "Long Short-Term Memory (LSTM)",
    DescriptionLSTMNetwork: "A special algorithm that is good at understanding relationships in temporal data. It is particularly good at recognising patterns in data with temporal dependencies." +
    "Since the LSTM has a kind of memory, it is able to recognise structures in time series that extend over a longer period of time.",
    QualityLSTMNetwork: 5,
    SpeedLSTMNetwork: 2,
    TitleGaussianMixtureNeuralNetwork: "Probabilistic Neuronal Network",
    DescriptionGaussianMixtureNeuralNetwork: "A neural network that instead of a value predicts the parameters of a Gaussian mixture distribution.",
    QualityGaussianMixtureNeuralNetwork: 4,
    SpeedGaussianMixtureNeuralNetwork: 1,
    TitleAFS: "Automated Feature Selection*",
    TitleAdditionalHPO: "Run additional Hyperparameter Optimization",
    DescriptionAFS: "In addition to the model hyperparameter search, an algorithm is performed that automatically selects the best features for training a model."+
        "This option is recommended for a large number of features or if you want to find out which features are negligible when solving the problem of your experiment."+
        "However, selecting this option not only increases the computational effort, but also the overall maintenance time.",
    TitlePipelineSteps: "Additional Training Pipeline Options",
    HintPipelineSteps: "Depending on the selected model type, additional steps for the training pipeline can be selected here",
    HintCanBeExecutedLater: "* These steps can also be executed later, after the model has been trained.",
    ExpectedQuality: "Expected Model Quality",
    ExpectedSpeed: "Expected Training Speed",
    SliderNumTrials: "Number of Trainings",
    HintNumTrials:
      "Select the number of runs for hyperparameter optimization", // TBD
    AdvancedOptions: "Advanced Options",
    OptimizationConfigTitle: "Optimization Config",
    HintOptimizationConfig: "⚠️ Expert feature! Here the settings of the hyperparameter optimization can be configured for your chosen model type. \n" +
          " Parameters that are not marked with 'optimize' are used in every training with the value 'init'.",
    HyperParamsPiplineStepsTitle: "Configuration for the pipeline step: ",
    HeaderType: "Type",
    HeaderScale: "Scale",
    StartButton: "Start Training Pipeline",
    SuccessPipelineStarted: "Run started",
    ErrorRunAlreadyExists:
      "A Run with the given name already exists \n for this Experiment. Please choose a different name.",
  },
    pipelineStatus: {
        PageTitle: "Pipeline status",
        PageDescription:
            "The following steps are part of your current pipeline.",
        InitializingInfo: "Initializing the pipeline \n Before the actual process begins, your job is queued to be executed on the servers. Depending on the server load, there may be some waiting time before the computation starts.",
    },
    // the Info in the Info columns seems to be static, but seems like that should not be part of this translation dict?
    trainingStatus: {
        PageTitle: "HPO Training Status",
        PageDescription:
            "The following steps are currently being carried out. Depending on your dataset size, this may take a while",
        TitleInfoBox: " Model Training Information",
        ModelTypeTitle: "Model Type",
        NumTrainTitle: "Maximum Number of Trainings",
        DatasetInfoTitle: "Datasets Information",
        ValRatioInfoTitle: "Training / Validation Ration",
        DescriptionValRatio: "Ratio between Training and Validation Set", // Should this be an Explanation or is the value supposed to go here
        TestsetInfoTitle: "Use Testset",
        DescriptionTestset: "You uploaded a testset for the experiment", // This is fake Information or does the button change color
        TimeInfoBox: "Time Information",
        TimeseriesInfoTitle: "Is Timeseries Data",
        DescriptionTimeseries:
            "Meaning, your dataset contains consecutive timestamps",
        SeasonalInfoTitle: "Is Seasonal Data",
        DescriptionSeasonal: "Meaning, your dataset spans over more than a year",
        PipelineProgressTitle: "Pipeline Step Progress",
        TrainingStepDescriptions: "Training Step Descriptions and Status",
        LabelStep1: "Hyperparameter Initialization",
        LabelStep2: "Hyperparameter Optimization and Model Training",
        LabelStep3: "Finish Training and Save Model",
        LabelStep4: "Create Plots and Calculate Scores",
        DescriptionStep1:
            "First, some initial values for the hyperparameters are chosen. The hyperparameter values are set by the predefined values or by using heuristic methods or randomly, depending on the model.",
        DescriptionStep2:
            "In this step, an optimization of the hyperparameters to the present use case takes place. For this purpose, the model is trained and then the model quality is assessed with the help of a validation data set. Based on the determined model quality, an optimization algorithm is then able to improve the hyperparameter selection for the next training. This process is iterated until the selected number of trainings has been reached.",
        DescriptionStep3:
            "After performing the specified number of training sessions, the training process is completed. The model is now saved to be reused for future predictions or fine-tuned to new data. A download of the model and the preprocessing pipeline is later available in the ONNX file format. ",
        DescriptionStep4:
            "In the final step, the performance of the model is evaluated. Depending on the model, both visual and numerical evaluation criteria can be used for this purpose. In this step, a set of appropriate qualitative and quantitative metrics is created. Using these metrics, different models can be compared to select the most appropriate model for the problem at hand. ",
        ReadNextButton: "Read Next",
        BackButton: "Back",
        CompletedMessage: "All steps completed - you're finished!",
        TrainingPlotsTitle: "HPO Visualization",
        ProceedButton: "Proceed to Results",
        // These are all related to the run status
            StatusTitle: "Run Status:",
            Initializing: "Initializing",
            RUNNING: "Active",
            NotRunning: "Not Running",
            Paused: "Paused",
            Completed: "Run Completed",
            FAILED: "Failed",
            CANCELLED: "Cancelled",
        FINISHED: "Finished",
            Undefinied: "Unknown",
        OptimizerResults: "Live Optimizer Results",
        ResetPlotViewButton: "Reset Plot View",
        ShowBestEpochButton: "Visualize best epoch",
        BestEpoch: "Best Optimization Epoch",
        BestSoFar: "Best Value",
        OptimizerEpoch: "Optimizer Epoch",
        Metric: "nRMSE",
        Trial: "Tested Value",
        Parcoord: "Hyperparameter Combination",
        CancelTrainingButton: "Cancel Training",
        FinalizeTrainingButton: "Finalize Training",
        CancelConfirmationMessage: "Are you sure you want to cancel the training?",
        ConfirmCancelButton: "Yes, cancel",
        CancelButton: "Cancel cancelation",
        CancelConfirmationTitle: "Cancel Training Confirmation",
        HintFinalizeTrainingButton: "This ends the optimization process early as gracefully as possible. It requires completing the current generation, saves the model, and creates the plots. This might take some time.",
        HintCancelTrainingButton: "This will stop the training process and delete the run.",
        FinalizeConfirmationTitle: "Finalize Training Confirmation",
        FinalizeConfirmationMessage: "Are you sure you want to finalize the training?",
        ConfirmFinalizeButton: "Yes, finalize",
        FinalizeButton: "Cancel finalization",
        SelectedHyperparameterRanges: "Selected Hyperparameter Ranges",
    },
    AFSTrainingStatus: {
        PageTitle: "Automatic Feature Selection (AFS) Training Status",
        PageDescription:
            "Trainings for the AFS are currently being carried out. Depending on your dataset size, this may take a while.",
        DescriptionSelectedFeatures: "Show selected features for each training run.",
        DescriptionLossCurve: "Show error curve-",
        HeatmapColorBarLabel: "Feature Status",
        HeatmapColorMax: "Selected",
        HeatmapColorMin: "Not Selected",
        HeatmapTitle: "Selected features per AFS training run",
        HeatmapXTitle: "AFS training run",
        HeatmapYTitle: "Features",
        ScatterTitle: "Features and Loss Progress",
        ScatterIntersectLabel: "Intersect",
        ScatterRobustLabel: "Robust",
        ScatterXAxisLabel: "AFS Training Run",
        ScatterYAxis1Label: "Loss (nRMSE)",
        ScatterYAxis2Label: "Number Selected Features",
    },
    tour: {
        BeaconTooltip: "Start Tutorial",
        AddDatasetButton: "First you need to add a dataset",
        CurrentDatasetSelector:
            "If you uploaded multiple datasets, you can choose one here",
        AddExperimentButton:
            "After you chose a dataset, you can add a new experiment for this dataset here. By using multiple experiments you can compare different trainings on the same dataset",
        CurrentExperimentSelector:
            "If you created multiple experiments for the same dataset, you can choose one here",
        CurrentExperimentProgress:
            "Here you can see the progress of your currently selected experiment, that means inspect the data,  run a training, etc",
        NextButton: "Next",
        BackButton: "Back",
        SkipButton: "Skip Tutorial",
    },

    about: {
        Header: 'About the AutoML KIlab.EE Tool',
        KilabDescription: "The AutoML KIlab.EE Tool enables the interactive communication of the benefits of AutoML and the creation of your own use cases. The AutoML Tool is available free of charge and is designed for small and medium-sized enterprises (SMEs) in Germany.",
        KndHeader: 'What is AutoML and how does it benefit small and medium-sized enterprises?',
        KndDescription: 'Automated Machine Learning (AutoML) is an emerging concept that aims to automate the application of machine learning as much as possible. When manually applying AI or machine learning, many steps are involved, which require expertise in the AI context.\n\n' +
            'For example:\n ' +
            '- Data preprocessing: AI models cannot process every type of data equally well. Therefore, it is important to be familiar with the AI models and to know which preprocessing steps are necessary to prepare the data ideally for model training.\n' +
            '- Model selection: Choosing which AI model is best suited for a given problem is not trivial. Depending on the data, the nature, and the complexity of the problem, different AI models must be chosen.\n' +
            '- Hyperparameter selection: Each AI model training can be configured with various hyperparameters. For example, the number of neurons in a neural network. Choosing these for a dataset requires extensive experience with AI models.\n' +
            'AutoML aims to automate these steps to a large extent. This not only saves AI professionals time-consuming work but also allows individuals or companies with limited AI expertise to create full-fledged AI applications without writing a single line of code.',
        ConceptHeader: 'What concepts are behind AutoML and how is it used in this tool?',
        ConceptDescription: 'AutoML is a complex research field that incorporates the accumulated knowledge of decades of AI application. Simply put, various predefined rules and optimization algorithms are used for automation.\n\n ' +
            'The AutoML KIlab.EE Tool aims to make the complexity of AutoML understandable and provide interactive insights into how it works. While using the tool, you will have access to explanatory hints to see where and how AutoML is applied.',
        Promotion: 'Promotion',
        MdzHeader: 'What is Mittelstand-Digital?',
        MdzDescription: 'The Mittelstand-Digital network offers comprehensive support for digitization with the Mittelstand-Digital Centers, the Initiative for IT Security in the Economy, and Digital Jetzt. Small and medium-sized enterprises benefit from concrete practical examples and tailored, provider-neutral offers for qualification and IT security. The Federal Ministry for Economic Affairs and Climate Action enables free use and provides financial subsidies. For more information, please visit www.mittelstand-digital.de',
        Contact: 'Contact',
        ContactQuestions: 'For questions or other feedback, please feel free to contact'
    }
};

translationEN.demo = demo;
export default translationEN;
